export default __webpack_public_path__ + "static/media/browser-wallet-dark.fffb81e2.svg";